<template>
<div>
  <test-plot
    :data="allEmails"
    />

  <el-column>
    <el-column-item style="min-width: auto;">
      <h2 :class="{ pending: count === 0 }">{{count}}</h2>
      <p>Total subscriber count</p>
    </el-column-item>
    <el-column-item style="min-width: auto;">
      <h2 :class="{ pending: count === 0 }">{{dayCount}}</h2>
      <p><b>New subs today</b><br>Total yesterday: {{yesterdayCount}}</p>
    </el-column-item>
    <el-column-item style="min-width: auto;">
      <h2 :class="{ pending: count === 0 }">{{weekCount}}</h2>
      <p><b>New subs this week</b><br>Total last week: {{lastWeekCount}}</p>
    </el-column-item>
  </el-column>

  <br>
  <h2>Search subscriber</h2>
  <el-input
    v-model="searchEmail"
    placeholder="Email"
    />
  <el-info
    v-for="sub in matchedSubscribers"
    :key="sub.email"
    >
    <el-inline :stretch="true" :space-between="true">
      <b>{{sub.email}}</b>
      <span style="margin-right: 10px;">{{sub.date}}</span>
    </el-inline>
  </el-info>

  <br><br>
</div>
</template>
<script>

import TestPlot from './TestPlot.vue'
import logScope from 'log-scope'

const log = logScope('SubscriberData')

export default {
  components: { TestPlot },
  data () {
    return {
      count: 0,
      dayCount: 0,
      weekCount: 0,
      yesterdayCount: 0,
      lastWeekCount: 0,
      searchEmail: '',
      allEmails: []
    }
  },
  computed: {
    matchedSubscribers () {
      let subs = []

      if (this.searchEmail === '') {
        return subs
      }

      return this.allEmails
        .filter(sub => sub.email.toLowerCase().indexOf(this.searchEmail.toLowerCase()) !== -1)
    },
    subscribers () {
      return this.$store.getters.subscribers
    }
  },
  watch: {
    subscribers: {
      deep: true,
      handler: 'update'
    }
  },
  mounted () {
    this.update()
  },
  methods: {
    update () {
      log.debug('update')

      let subs = this.subscribers
      let now = new Date()
      let month = now.getMonth()
      let year = now.getFullYear()
      let date = now.getDate()
      let dayOfWeek = now.getDay() - 1
      let todayStart = +(new Date(year, month, date))
      let mondayStart = +(new Date(year, month, date - dayOfWeek))
      let mondayLastWeek = +(new Date(year, month, date - dayOfWeek - 7))
      let yesterdayStart = +(new Date(year, month, date - 1))
      let emails = {}

      Object.entries(subs).forEach(([id, sub]) => {
        let email = sub.email
        let timestamp = sub.timestamp

        if (!emails[email]) {
          emails[email] = {
            quantity: 1,
            date: (new Date(timestamp)).toDateString()
          }

          // Today
          if (timestamp > todayStart) {
            this.dayCount++
          }

          // Yesterday
          if (timestamp > yesterdayStart && timestamp < todayStart) {
            this.yesterdayCount++
          }

          // This week
          if (timestamp > mondayStart) {
            this.weekCount++
          }

          // Previous week
          if (timestamp > mondayLastWeek && timestamp < mondayStart) {
            this.lastWeekCount++
          }
        } else {
          emails[email].quantity++
        }
      })

      // log.debug('Duplicates',
      //   Object.entries(emails)
      //     .filter(([_email, { quantity }]) => quantity > 1)
      //     .map(([email]) => email)
      // )

      this.count = Object.keys(emails).length
      this.allEmails = Object.entries(emails)
        .map(([email, { date }]) => ({ email, date }))
        .reverse()
    }
  }
}
</script>
<style scoped>
  .pending {
    color: #cacaca;
  }
</style>
